import React from "react"

export default function Contact() {
    return (
        <main>
            <section className="contact">
                <div className="contactDecorationBallOne"></div>
                <div className="contactInfo">
                    <h1 data-aos="fade-up" data-aos-once="true" data-aos-delay="500">Contact Us</h1>
                    <p className="contactInfoText" data-aos="fade-up" data-aos-once="true" data-aos-delay="700">Lorem Ipsum Dolor Sit Amet, Ipsum Sit Amet Convectur Sit Amit</p>
                    <div className="contactInfoInfo">
                        <div className="contactInfoElement" data-aos="fade-up" data-aos-once="true" data-aos-delay="900">
                            <i className="fa-solid fa-envelope contactInfoElementIcon"></i>
                            <p>noone@shaw.ca</p>
                        </div>
                        <div className="contactInfoElement" data-aos="fade-up" data-aos-once="true" data-aos-delay="1000">
                            <i className="fa-solid fa-phone contactInfoElementIcon"></i>
                            <p>(1) 000 000 0000</p>
                        </div>
                        <div className="contactInfoElement" data-aos="fade-up" data-aos-once="true" data-aos-delay="1100">
                            <i className="fa-solid fa-location-dot contactInfoElementIcon"></i>
                            <p>location street 123</p>
                        </div>
                    </div>
                </div>
                <div className="contactForm" data-aos="fade-up" data-aos-once="true" data-aos-delay="1300">
                    <form className="contactFormContainer">
                        <h2>Contact Form</h2>
                        <div className="locationFormData">
                            <div className="locationFormElement">
                                <input type="text" placeholder="Name" required/>
                                <div></div>
                            </div>
                        </div>
                        <div className="locationFormData">
                            <div className="locationFormElement">
                                <input type="email" placeholder="Email" required/>
                                <div></div>
                            </div>
                        </div>
                        <div className="locationFormData">
                            <div className="locationFormElement">
                                <input type="text" placeholder="Phone" required/>
                                <div></div>
                            </div>
                        </div>
                        <div className="locationFormData">
                            <div className="locationFormElement">
                                <input type="text" placeholder="Message" required/>
                                <div></div>
                            </div>
                        </div>
                        <div className="locationFormButtonAlign">
                            <button>Submit</button>
                        </div>
                    </form>
                </div>
                <div className="contactDecorationBallTwo"></div>
            </section>
        </main>
    )
}